export default __webpack_public_path__ + "images/1526758c2e28955976a41ae864a0e40d.png";